<template>
	<div class="min-height-inherit">
		<div class="row justify-content-center align-items-center min-height-inherit">
			<div id="change-pwd-box" class="col-sm-10 col-md-8 col-lg-7 col-xl-6 py-5 px-4 min-height-inherit my-4">
				<div class="row justify-content-center">
					<div class="col-12 text-center">
						<h1 class="fs-2-7 mb-4">Crea la tua nuova password</h1>
						<p class="semibold font-family-juve fs-1-3 mb-5">Deve avere almeno 8 caratteri, una lettera maiuscola, un numero e un carattere speciale.</p>
					</div>
					<div class="col-12 mb-3">
						<form id="change-password-request" @submit.prevent="onSubmitForm">
							<div class="row justify-content-center">
								<div class="col-xxl-8 col-xl-10">
									<div class="row">
										<div class="col-12 form-group">
											<input type="email" name="e-mail" id="e-mail" class="form-control form-control-lg mb-0"  maxlength="150" disabled :value="mail" style="border-radius:50rem !important;border:2px solid #9AC10C !important;">
										</div>
										<div class="col-12 form-group">
											<label class="fs-0-8 mb-0" for="password">Nuova password</label>
											<input :type="pwdInputType" name="password" id="password" class="form-control form-control-lg pwd-show mb-0" required  autocomplete="aut_off_iuasdsvkz" maxlength="100" minlength="8" v-model="password" style="border-radius:50rem !important;border:2px solid #9AC10C !important;">
											<i class="fa fa-eye" :class="{'fa-eye' : !showPwd, 'fa-eye-slash' : showPwd}" aria-hidden="true" @click.prevent="showHidePwd"></i>
										</div>

										<div class="col-12 form-group mb-2">
											<label class="fs-0-8 mb-0" for="retype-email">Conferma nuova password</label>
											<input :type="pwdInputType" name="retype-password" id="retype-password" class="form-control form-control-lg pwd-show mb-0" required  autocomplete="aut_off_iuasdsvkz" maxlength="100" minlength="8" v-model="retypePasseord" style="border-radius:50rem !important;border:2px solid #9AC10C !important;">
											<i class="fa fa-eye" :class="{'fa-eye' : !showPwd, 'fa-eye-slash' : showPwd}" aria-hidden="true" @click.prevent="showHidePwd"></i>
										</div>
									</div>
								</div>
								<div class="col-12 form-group text-center mt-4 mb-2">
									<button type="submit" id="sub-mail" class="btn btn-green rounded-pill btn-lg px-5" :disabled="isBtnDisabled">SALVA</button>
								</div>
								<div class="col-12 mb-5" v-if="formMsg">
									<span v-html="formMsg"></span>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- ** Modal ************************* -->
		<modal
			id="confirm-changes"
			name="confirm-changes"
			height="auto"
			:adaptive=true
			classes="rounded-default"
		>
			<div class="p-3 pt-0">
				<div class="container" style="background-color:#fff;border-radius:2rem;min-height:auto;">
					<div class="row" style="min-height:auto;">
						<div class="col-12 text-end pe-0">
							<svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" fill="#01623f" class="bi bi-x hover-default" viewBox="0 0 16 16"  @click.prevent="hideModal" style="margin-right:-15px">
								<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
							</svg>
						</div>
					</div>
					<div class="row" style="min-height:auto;">
						<div class="col-12 mb-3 text-center">
							<h2 class="fs-3">Password salvata!</h2>
							<p>Annota le tue credenziali per i prossimi accessi.</p>
						</div>
						<div class="col-12 text-center mb-4">
							<a :href="siteUrl" id="redirect-button" class="btn btn-green rounded-pill btn-lg px-4">ENTRA NELL’AREA DOCENTE</a>
						</div>
					</div>
				</div>
			</div>
		</modal>

	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'CangePasswordFormComponent',
	props: ['mail', 'codex', 'name'],

	data() {
		return {
			ajaxObj: window.ajax_object,
			isBtnDisabled: false,
			formMsg: '',
			password: '',
			retypePasseord: '',
			siteUrl: '',
			showPwd: false,
			pwdInputType: 'password'
		}
	},

	methods: {
		onSubmitForm() {
			let url = this.ajaxObj.ajax_url
			this.isBtnDisabled = true
			this.formMsg = ''

			var data = new FormData();
			data.append('action', 'nl_change_wp_password')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('password', this.password)
			data.append('retypePassword', this.retypePasseord)
			data.append('key', this.codex)

			axios.post(url, data)
				.then((response) => {
					let _this = this
					// console.log(response.data)
					if(response.data.error == '') {
						// this.formMsg = response.data.msg
						this.siteUrl = response.data.site_url
						this.password = ''
						this.retypePasseord = ''
						_this.$modal.show('confirm-changes')
					} else {
						this.formMsg = '<span>' + response.data.error + '</span>'
					}
					this.isBtnDisabled = false
				}, (error) => {
					this.isBtnDisabled = false
					console.log(error);
				});
		},

		hideModal() {
			this.$modal.hide();
			window.location.replace(this.siteUrl);
		},

		showHidePwd() {
			if(this.pwdInputType == 'password') {
				this.pwdInputType = 'text'
				this.showPwd = true
			} else {
				this.pwdInputType = 'password'
				this.showPwd = false
			}
		}

	},

	mounted() {
		// this.$modal.show('confirm-changes')
	}
}
</script>

<style scoped>
	.pwd-show {
		display: inline-block;
	}
	.fa.fa-eye {
		margin-left: -30px;
		cursor: pointer;
		color: #79a52b;
	}
</style>
